/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
/* Services */

/**
 * Renders the Features component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} Features component
 */

const Features = ({ sectionContent, region, language }) => {
  const featureData = sectionContent.body.find(
    el => el.sectionId == 'Feature-Description'
  );
  return (
    <>
      <Box className="featuredesc">
        <Box
          display={{ base: 'block' }}
          justifyContent="center"
          margin={{ base: '0 auto', lg: '20px auto 0' }}
          maxW={{ base: '100%', lg: '1024px' }}
          position="relative"
        >
          <Box width={{ base: '90%', lg: '80%' }} m="0 auto">
            <Text
              fontSize={{ base: '14px', lg: '16px' }}
              color="#ffbd31"
              margin="0 0 20px 0"
              letterSpacing="2px"
              fontFamily="FedraSansStd-book"
              textTransform="uppercase"
              textAlign="center"
            >
              {featureData?.sectionContent[0]?.titleSubtext}
            </Text>
            <Text
              as="h2"
              fontSize={{ lg: '42px', base: '24px' }}
              fontFamily="FedraSansStd-A-medium"
              color="#ffffff"
              textAlign="center"
            >
              {featureData?.sectionContent[0]?.titleText}
            </Text>
            <Box
              as="p"
              color="#ffffff"
              textAlign="center"
              fontSize={{ base: '18px', lg: '26px' }}
              m="15px auto"
            >
              {featureData?.sectionContent[1].text}
            </Box>
            <Box
              color="#ffffff "
              maxW={{ base: '90%', lg: '830px' }}
              fontFamily="FedraSansStd-book"
              fontSize={{ base: '16px', lg: '22px' }}
              lineHeight="150%"
              m="10px auto"
              p="20px 0 0 0"
              className="benefits"
            >
              {StructuredTextContent(featureData?.sectionContent[2]?.body)}
            </Box>
          </Box>
        </Box>
        <style global jsx>{`
          .benefits ul {
            margin-top: 20px;
          }
          .benefits li {
            padding: 14px 0;
          }
        `}</style>
      </Box>
    </>
  );
};

export default Features;
